import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClassicCakesComponent } from './classic-cakes.component';

const routes: Routes = [
  {
    path: '',
    component: ClassicCakesComponent
  },
  {
    path: ':id',
    component: ClassicCakesComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClassicCakesRoutingModule { }
